/**
 * @generated SignedSource<<6d28712e82d6c72896f0d668ad724ac4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GrowthRecContext = {
  anonymousId?: string | null | undefined;
  containers?: any | null | undefined;
  custom?: any | null | undefined;
  locale?: string | null | undefined;
  orgId?: string | null | undefined;
  product?: string | null | undefined;
  sessionId?: string | null | undefined;
  subproduct?: string | null | undefined;
  tenantId?: string | null | undefined;
  useCase?: string | null | undefined;
  userId?: string | null | undefined;
  workspaceId?: string | null | undefined;
};
export type useSearchRecommendationsQuery$variables = {
  context: GrowthRecContext;
  first?: number | null | undefined;
};
export type useSearchRecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly data?: ReadonlyArray<{
        readonly entityId: string;
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSearchRecommendationsQuery = {
  response: useSearchRecommendationsQuery$data;
  variables: useSearchRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "context"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "context",
    "variableName": "context"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSearchRecommendationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "GrowthRecRecommendations",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSearchRecommendationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "GrowthRecRecommendations",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0ef28162efabf00e4a9717b186eded38",
    "id": null,
    "metadata": {},
    "name": "useSearchRecommendationsQuery",
    "operationKind": "query",
    "text": "query useSearchRecommendationsQuery(\n  $context: GrowthRecContext!\n  $first: Int\n) {\n  growthRecommendations {\n    recommendations(first: $first, context: $context) {\n      __typename\n      ... on GrowthRecRecommendations {\n        data {\n          __typename\n          entityId\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1325379d7100beb456ed1b6e5bc220a";

export default node;
